import { IVehicleItem, vehicle_types } from '@helpers/types';
import {
  DirectionsCar,
  ElectricRickshaw,
  FlashOn,
  LocalShipping,
  TransferWithinAStation,
  TwoWheeler,
} from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import _ from 'lodash';

export const GENERIC_REDUCER = (state: any, payload: any) => {
  if (payload) return _.merge({ ...state }, { ...payload });
  else return state;
};

const customizer = (_objValue: any, srcValue: any) => {
  if (srcValue === undefined) {
    return null;
  }
  if (_.isArray(srcValue)) {
    return srcValue;
  }
};
export const GENERIC_REDUCER_EXTENDED = (state: any, payload: any) => {
  if (payload) {
    const new_state = _.mergeWith({ ...state }, { ...payload }, customizer);
    for (const key in new_state) {
      if (new_state[key] === null) {
        delete new_state[key];
      }
    }
    return new_state;
  } else return state;
};

export function stringToColor(string: string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

export function stringAvatar(name: string) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
}

export const vehicles: Array<IVehicleItem> = [
  {
    value: vehicle_types.motorcycle,
    label: 'Motocicleta',
    icon: <TwoWheeler fontSize="inherit" color="primary" />,
  },
  {
    value: vehicle_types.auto,
    label: 'Automóvil',
    icon: <DirectionsCar fontSize="inherit" color="primary" />,
  },
  {
    value: vehicle_types.small_van,
    label: 'Van[sm]',
    icon: (
      <>
        <LocalShipping fontSize="inherit" color="primary" />
        <sup>sm</sup>
      </>
    ),
  },
  {
    value: vehicle_types.large_van,
    label: 'Van[lg]',
    icon: (
      <>
        <LocalShipping fontSize="inherit" color="primary" />
        <sup>lg</sup>
      </>
    ),
  },
  {
    value: vehicle_types.same_day,
    label: 'Same Day',
    icon: <FlashOn fontSize="inherit" color="primary" />,
  },
  {
    value: vehicle_types.electric_van,
    label: 'Van eléctrica',
    icon: <ElectricRickshaw fontSize="inherit" color="primary" />,
  },
];

export const vehicles_joins: Array<IVehicleItem> = [
  {
    value: vehicle_types.motorcycle,
    label: 'Motocicleta',
    icon: <TwoWheeler fontSize="inherit" color="primary" />,
  },
  {
    value: vehicle_types.auto,
    label: 'Automóvil',
    icon: <DirectionsCar fontSize="inherit" color="primary" />,
  },
  {
    value: vehicle_types.small_van,
    label: 'Van[sm]',
    icon: (
      <>
        <LocalShipping fontSize="inherit" color="primary" />
        <sup>sm</sup>
      </>
    ),
  },
  {
    value: vehicle_types.large_van,
    label: 'Van[lg]',
    icon: (
      <>
        <LocalShipping fontSize="inherit" color="primary" />
        <sup>lg</sup>
      </>
    ),
  },
];

export const vehicle_by_id: Record<
  number,
  { icon: React.ReactNode; label: string }
> = {
  0: {
    icon: <TwoWheeler fontSize="inherit" color="primary" />,
    label: 'Motocicleta',
  },
  1: {
    icon: <DirectionsCar fontSize="inherit" color="primary" />,
    label: 'Automóvil',
  },
  2: {
    icon: (
      <>
        <LocalShipping fontSize="inherit" color="primary" />
        <sup>sm</sup>
      </>
    ),
    label: 'Van[sm]',
  },
  3: {
    icon: (
      <>
        <LocalShipping fontSize="inherit" color="primary" />
        <sup>lg</sup>
      </>
    ),
    label: 'Van[lg]',
  },
};

export const vehicle_icons: any = {
  [vehicle_types.motorcycle]: <TwoWheeler fontSize="inherit" color="primary" />,
  [vehicle_types.auto]: <DirectionsCar fontSize="inherit" color="primary" />,
  [vehicle_types.small_van]: (
    <>
      <LocalShipping fontSize="inherit" color="primary" />
      <sup>sm</sup>
    </>
  ),
  [vehicle_types.large_van]: (
    <>
      <LocalShipping fontSize="inherit" color="primary" />
      <sup>lg</sup>
    </>
  ),
  [vehicle_types.same_day]: <FlashOn fontSize="inherit" color="primary" />,
  [vehicle_types.electric_van]: (
    <ElectricRickshaw fontSize="inherit" color="primary" />
  ),
  [vehicle_types.x]: (
    <Tooltip title="Vehículos no disponibles" placement="top">
      <TransferWithinAStation fontSize="inherit" color="error" />
    </Tooltip>
  ),
};

export const string_to_slug = (str: any) => {
  if (typeof str !== 'string') return 'lorem';
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
  const to = 'aaaaeeeeiiiioooouuuunc------';
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return str;
};

export const TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const TIME_EXPIRATION_CONTAINERS = 24; // hours

export const DELIVERY_TYPES = [
  { code: 'SMD', friendly: 'SameDay' },
  { code: 'NXD,SPT', friendly: 'Sprint' },
  { code: '99M', friendly: 'Express' },
  { code: 'CO2', friendly: 'CO2 Free' },
  { code: 'RET', friendly: 'Retorno' },
  { code: 'NAL', friendly: 'Nacional' },
  { code: 'P2P', friendly: 'Punto a punto' },
  { code: 'TLM', friendly: 'Tailormade' },
  { code: 'ECO', friendly: 'Economy' },
];
